export interface DeleteSeparateDictionaryRequest {
  id: number
  revision: number
}

export function DeleteSeparateDictionaryRequestToJSON(
  value: DeleteSeparateDictionaryRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
